import React from "react"
import { useHistory } from "react-router-dom"
import { Button } from "reactstrap"

function BackButton({ label = "キャンセル ", className = "" }) {
  const history = useHistory()
  return (
    <Button
      className={className}
      onClick={() => history.goBack()}
      color="warning"
    >
      {label}
    </Button>
  )
}

export default BackButton
